import type { FC, HTMLAttributes, ReactNode } from "react";

type Props = {
  children: ReactNode;
  title: string;
};

type Style = HTMLAttributes<HTMLElement>["style"];

const PdfPreviewSection: FC<Props> = ({ children, title }) => {
  const wrapper: Style = {
    width: "100%",
    padding: "0 2px 2px 2px",
    borderBottom: "1px solid #000",
    position: "relative",
  };

  const heading: Style = {
    width: "100%",
    display: "inline-block",
    fontSize: 14,
    lineHeight: 1,
    fontWeight: "bold",
    color: "#000",
    textAlign: "left",
    margin: "0 0 0 0",
    position: "relative",
    alignContent: 'center'
  };

  const content: Style = {
    width: "100%",
    padding: "6px 2px 0 2px",
    margin: "0 0 6px 0",
    position: "relative",
  };

  return (
    <>
      <div style={wrapper}>
        <h2 style={heading}>{title}</h2>
      </div>
      <div style={content}>{children}</div>
    </>
  );
};

export default PdfPreviewSection;
